<template>
  <div class="flex">
    <section class="action">
      <h4>
        {{ $t('courseConnection.nextCourses.actions.hold.title') }}
      </h4>
      <p>
        {{ $t('courseConnection.nextCourses.actions.hold.description') }}
      </p>
      <btn variant="danger" @click="$emit('blockCourses')">
        <Icon id="stop"></Icon>
        {{ $t('courseConnection.nextCourses.actions.hold.button') }}
      </btn>
    </section>
    <section class="action action--left-border">
      <h4>
        {{ $t('courseConnection.nextCourses.actions.addDelay.title') }}
      </h4>
      <p>
        {{ $t('courseConnection.nextCourses.actions.addDelay.description') }}
      </p>
      <div class="flex">
        <InputNumber v-model="delay" unit="min" :min="1" />
        <btn
          variant="warning"
          class="flex-grow-1 mrgl"
          @click="$emit('delayDeparture', delay)"
        >
          <Icon id="clock"></Icon>
          {{ $t('courseConnection.nextCourses.actions.addDelay.button') }}
        </btn>
      </div>
    </section>
    <section class="action action--left-border">
      <h4>
        {{ $t('courseConnection.nextCourses.actions.standard.title') }}
      </h4>
      <p>
        {{ $t('courseConnection.nextCourses.actions.standard.description') }}
      </p>
      <btn variant="primary" @click="$emit('releaseCourses')">
        <Icon id="check"></Icon>
        {{ $t('courseConnection.nextCourses.actions.standard.button') }}
      </btn>
    </section>
  </div>
</template>

<script>
import InputNumber from '@/components/ui/InputNumber';
export default {
  name: 'ActionsVue',
  components: { InputNumber },
  data() {
    return {
      delay: 1,
    };
  },
};
</script>

<style lang="scss" scoped>
.action {
  padding: 0 0.7rem 0.7rem 1.5rem;

  &--left-border {
    border-left: $list-separator-style-dark;
  }
}
</style>
